module.exports = __webpack_public_path__ + "static/media/Pier_1.8f676806.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/outskirts/pier/Pier_1.png
// module id = 1317
// module chunks = 3